<template>
  <v-layout>
    <v-dialog v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="800px" persistent lazy>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-btn icon dark @click.stop="show=false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Contact List</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
          <!-- <v-btn dark flat @click="savePayment">Save</v-btn> -->
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <vue-good-table
          ref="my-table"
          styleClass="vgt-table striped bordered"
          :max-height=this.height
          :fixed-header="true"
          :isLoading=this.isTableLoading
          :columns="columns"
          :rows="rows"
          :search-options="{
            enabled: true
          }">
          <template slot="loadingContent">
            <div>
              <v-progress-circular
                :size="50"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
          <!-- <div slot="table-actions-bottom">
            <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
          </div> -->
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'name'">
              <v-layout align-center justify-start row fill-height>
                <v-flex xs12>
                  {{ props.row.firstName }} {{ props.row.lastName }}<br /> ({{ props.row.type }})
                </v-flex>
              </v-layout>
            </span>
            <span v-if="props.column.field == 'phone'">
              <v-layout align-center justify-start row fill-height>
                <v-flex xs12>
                  {{ props.row.phone }}<br /> {{ props.row.mobile }}
                </v-flex>
              </v-layout>
            </span>
            <span v-else-if="props.column.field == 'email'">
              <v-layout align-center justify-start row fill-height>
                <v-flex xs12>
                  <a :href="'mailto:' + props.row.email" style="text-decoration: none;">
                    {{ props.row.email }}
                  </a>
                </v-flex>
              </v-layout>
            </span>
            <span v-else-if="props.column.field == 'actions'">
              <div class="text-xs-center">
                <v-avatar
                  color="blue lighten-4"
                  class="mr-2 mt-2"
                  size="30"
                  style="cursor: pointer;"
                  @click="editItem(props)"
                >
                  <v-icon small>edit</v-icon>
                </v-avatar>
              </div>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="newItem">Add</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="closeThisEval">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add/Edit Contact</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
              <v-btn dark flat @click="save">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs12>
                  <v-select
                    :items="contactTypes"
                    v-model="evalItem.type"
                    label="Type"
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.firstName"
                    @keyup.enter="save"
                    label="First Name"
                    :rules="[v => !!v || 'First Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.lastName"
                    @keyup.enter="save"
                    label="Last Name"
                    :rules="[v => !!v || 'Lasty Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.title"
                    @keyup.enter="save"
                    label="Title"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="evalItem.phone"
                    @keyup.enter="save"
                    label="Phone"
                    mask="(###) ###-####"
                    return-masked-value
                    :rules="[v => !!v || 'Primary Phone is required']"
                    prepend-icon="phone"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="evalItem.mobile"
                    @:keyup.enter="save"
                    label="Mobile"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="stay_current_portrait"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="evalItem.fax"
                    @:keyup.enter="save"
                    label="Fax"
                    prepend-icon="mdi-fax"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.email"
                    @keyup.enter="save"
                    label="Email Address"
                    prepend-icon="email"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    </v-dialog>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

export default {
  props: ['visible', 'item'],

  components: {
    VueGoodTable
  },

  data () {
    return {
      page: 'list',
      valid: true,
      searchSelect: [],
      currentYear: 0,
      isCommChair: false,
      dialog: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Name/Type',
          field: 'name',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Phone/Mobile',
          field: 'phone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Email',
          field: 'email',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          html: true
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: false,
          html: true,
          width: '60px'
        }
      ],
      rows: [],
      editedItem: {},
      evalItem: {},
      showEvalForm: false,
      contactTypes: ['Contact', 'Secondary', 'Billing', 'Primary Onsite', 'Secondary Onsite']
    }
  },

  created () {
    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getContacts()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    // totalCount () {
    //   if (!this.isMounted) {
    //     return
    //   }

    //   return this.$refs['my-table'].totalRowCount
    // },
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    newItem () {
      this.evalItem = {}
      this.dialog = true
    },

    editItem (props) {
      this.evalItem = props.row
      this.dialog = true
    },

    save () {
      // if (this.$refs.form.validate()) {
      if (this.evalItem.id > 0) {
        // console.log('Update')
        this.updateItem(this.editedItem)
      } else {
        // console.log('Save')
        this.addItem(this.editedItem)
      }
      // } else {
      //   this.snackbar.message = 'You have some errors on the page!'
      //   this.snackbar.color = 'error'
      //   this.snackbar.show = true
      // }
    },

    async addItem () {
      try {
        this.evalItem.VendorCompanyId = this.item.id
        const response = await Api().post('extern_vendor_contacts', this.evalItem)
        const contact = response.data.contact

        this.rows.push(contact)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        const response = await Api().put('extern_vendor_contacts/' + this.evalItem.id, this.evalItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteItem (committeeId) {
      let r = confirm('Are you sure you want to remove this committee?')

      if (r === true) {
        try {
          const response = await Api().delete('vendor_contacts/' + this.evalItem.id)

          this.rows.splice(this.editedIndex, 1)
          this.close()

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async getContacts () {
      this.isCommChair = false

      try {
        const response = await Api().get('extern_vendor_contacts/' + this.item.id)

        this.rows = response.data

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    closeThisEval (item) {
      // const evalmem = item
      // let index = this.rows.findIndex(row => row.id === evalmem.UserId)
      // this.rows[index].eval = evalmem
      this.evalItem = {}
      this.dialog = false
    },

    close () {
      this.initialImage = null
      this.dialog = false
      this.showEmailForm = false
      this.showEvalForm = false
      this.show = false

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/vendorExtern/ContactList.vue